import { render, staticRenderFns } from "./single_criterion.vue?vue&type=template&id=1812ee5f&scoped=true&"
import script from "./single_criterion.vue?vue&type=script&lang=ts&"
export * from "./single_criterion.vue?vue&type=script&lang=ts&"
import style0 from "./single_criterion.vue?vue&type=style&index=0&id=1812ee5f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1812ee5f",
  null
  
)

export default component.exports